// Gravedad. Ver docs/theory/environment.md.
import { G0 } from '../atmosphere/isa';

export interface GravityModel {
  /** Aceleración de la gravedad (m/s²) a latitud `latitude` (rad) y altitud `altitude` (m). */
  at(latitude: number, altitude: number): number;
}

export const constantGravity = (g: number = G0): GravityModel => ({ at: () => g });

const A = 6_378_137;
const F = 1 / 298.257223563;
const M = 0.00344978650684;

/** Gravedad normal WGS84 (Somigliana) con corrección de aire libre. */
export const wgs84Gravity: GravityModel = {
  at(latitude: number, altitude: number): number {
    const s2 = Math.sin(latitude) ** 2;
    const surface =
      (9.7803253359 * (1 + 0.00193185265241 * s2)) / Math.sqrt(1 - 0.00669437999013 * s2);
    const h = altitude;
    return surface * (1 - ((2 * h) / A) * (1 + F + M - 2 * F * s2) + (3 * h * h) / (A * A));
  },
};
